<template>
  <div class="brb-input">
    <validation-provider
      :vid="vid"
      :rules="computedValidation"
      :name="errorName || label"
      v-slot="{ errors, classes }"
    >
      <component
        ref="brb-input"
        :is="component"
        :class="[attrs.class, classes, { empty }]"
        v-model="model"
        v-bind="attrs"
        v-on="$listeners"
      />

      <span v-if="label" class="label font-weight-bold mb-0">
        {{ label }}
        <span v-if="required" class="text-danger"> * </span>
      </span>

      <span v-if="append" :class="['append mb-0 pr-3 border-right']">
        {{ append }}
      </span>

      <span v-if="unit || currency" class="unit mb-0">
        {{ unit || $t(`currency.${$config.currency.display}`) }}
      </span>

      <span
        v-if="errors && errors.length"
        class="d-block text-right text-danger small mt-2"
      >
        {{ errors[0] }}
      </span>
    </validation-provider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'BrbInput',
  components: {
    NumericInput: () => import('./components/NumericInput.vue'),
    ValidationProvider
  },
  inheritAttrs: false,
  props: {
    value: {
      default: null
    },
    validation: {
      type: [String, Object],
      default: null
    },
    label: String,
    errorName: String,
    vid: String,
    inputStyle: [String, Array, Object],
    inputClass: [String, Array, Object],
    unit: String,
    hideClear: Boolean,
    append: String,
    // types of input
    numeric: Boolean,
    mobile: Boolean,
    phone: Boolean,
    nationalId: Boolean,
    currency: Boolean,
    textarea: Boolean
  },
  computed: {
    component() {
      if (
        this.numeric ||
        this.mobile ||
        this.phone ||
        this.nationalId ||
        this.currency
      ) {
        return 'numeric-input'
      }

      if (this.textarea) return 'b-textarea'

      return 'b-input'
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    empty() {
      return this.model === null || this.model === ''
    },
    attrs() {
      const attrs = {
        autocomplete: 'off',
        class: this.inputClass,
        style: this.inputStyle,
        ...this.$props,
        ...this.$attrs
      }

      if (this.currency) {
        attrs.separator = true
      }

      // TODO: implement
      // if (attrs.type === 'password') {
      //   attrs.type = this.showPassword ? 'text' : 'password'
      // }

      return attrs
    },
    computedValidation() {
      if (this.mobile) {
        return this.addValidation('mobile')
      }

      if (this.phone) {
        return this.addValidation('phone')
      }

      if (this.nationalId) {
        return this.addValidation('national-id')
      }

      return this.validation
    },
    required() {
      if (this.validation) {
        if (typeof this.validation === 'string')
          return this.validation.includes('required')

        if (
          typeof this.validation === 'object' &&
          Object.keys(this.validation).includes('required')
        )
          return this.validation.required
      }

      return false
    }
  },
  methods: {
    focus() {
      if (this.$refs['brb-input']) this.$refs['brb-input'].focus()
    },
    addValidation(validation) {
      if (this.validation) {
        if (typeof this.validation === 'string') {
          return `${this.validation}|${validation}`
        }

        if (typeof this.validation === 'object') {
          return {
            ...this.validation,
            [validation]: true
          }
        }
      }

      return validation
    }
  }
}
</script>

<style lang="scss">
@import '~/src/assets/scss/components/brb-components/brb-input';
</style>
